// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { Helmet, HelmetProvider } from 'react-helmet-async';

import HomePage from './HomePage';
import AdminPage from './AdminPage';
import AdminHome from "./AdminHome";
// ✅ import your new category page
import CategoryPage from './components/CategoryPage';
import AdminLogin from "./pages/AdminLogin";
import ProtectedRoute from "./components/ProtectedRoute";
import ProductsPage from './ProductsPage';
import ProductDetailPage from './ProductDetailPage';
import BulkProductsWizard from './BulkProductsWizard';
import AdminProductsManager from './AdminProductsManager';
import BlogsPage from "./pages/BlogsPage";
import { BlogDetails } from "./pages/BlogDetails";
import { AddEditBlog } from "./pages/AddEditBlog";
import AddProductPage from './AddProductPage';
import PartnershipPage from './pages/PartnershipPage';
import TermsConditions from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import DeleteAccount from "./pages/DeleteAccount";
function App() {
  return (
    <Router>
      <HelmetProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/deleteaccount" element={<DeleteAccount />} />

          {/* ✅ Category Management Page */}
          <Route path="/categories" element={<CategoryPage />} />

          {/* Existing Admin Page */}

          {/* Product Listing Page */}
          <Route path="/collection/:gender/:subcategoryName" element={<ProductsPage />} />
<Route path="/admin-login" element={<AdminLogin />} />

<Route 
  path="/admin" 
  element={
    <ProtectedRoute>
      <AdminHome />
    </ProtectedRoute>
  } 
/>

<Route 
  path="/admin/products" 
  element={
    <ProtectedRoute>
      <AdminProductsManager />
    </ProtectedRoute>
  }
/>

<Route 
  path="/admin/bulk-products" 
  element={
    <ProtectedRoute>
      <BulkProductsWizard />
    </ProtectedRoute>
  }
/>

<Route 
  path="/admin/add-product" 
  element={
    <ProtectedRoute>
      <AddProductPage />
    </ProtectedRoute>
  }
/>
          {/* Product Details Page */}
          <Route path="/product/:gender/:subcategoryName/:productId" element={<ProductDetailPage />} />
        <Route path="/blog" element={<BlogsPage/>} />
                <Route path="/partner" element={<PartnershipPage/>} />
<Route path="/terms" element={<TermsConditions />} />
<Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/blog/new" element={<AddEditBlog/>} />
        <Route path="/blog/:slug" element={<BlogDetails/>} />
          {/* 404 Fallback */}
          <Route
            path="*"
            element={
              <div style={{ padding: "60px 20px", textAlign: "center", minHeight: "60vh", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                <Helmet>
                  <title>Page Not Found | DOR Dress On Rent</title>
                  <meta name="robots" content="noindex, nofollow" />
                </Helmet>
                <h1 style={{ fontSize: "2.5rem", marginBottom: "12px", color: "#111" }}>404 - Page Not Found</h1>
                <p style={{ color: "#666", marginBottom: "24px", maxWidth: "450px" }}>The page you are looking for does not exist or may have been moved.</p>
                <Link to="/" style={{ display: "inline-block", padding: "12px 28px", backgroundColor: "#111", color: "#fff", borderRadius: "999px", textDecoration: "none", fontWeight: 500 }}>
                  Back to Homepage
                </Link>
              </div>
            }
          />
        </Routes>
      </HelmetProvider>
    </Router>
  );
}

export default App;
